'use client'
import React from 'react'
import Image from 'next/image'

import { trackEvent } from '@/utils/analytics'
import { PrismicNextImage } from '@prismicio/next'
import { PrismicRichText } from '@prismicio/react'
import { useRouter, usePathname } from 'next/navigation'

type DataObject = Record<string, any>

const Product = ({ data }: { data: DataObject }) => {
  const router = useRouter()
  const pathname = usePathname()

  const productData = {
    title: data.cta_title[0]?.text,
    content: data.cta_content[0]?.text,
    srcPath: `https://secureframe.com${pathname}`,
    destPath: `${data?.download_link?.url ? data.download_link.url : 'https://secureframe.com/request-demo'}`,
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    router.push(productData.destPath)

    trackEvent('Recommended Reading Clicked', productData)
  }

  return (
    <div className="my-8 grid grid-cols-2 rounded-md border border-secondary-gray-150 p-8 shadow-light backdrop-blur-25">
      <div className="self-center [&>h2]:m-0 [&>h2]:text-3xl [&>h2]:tracking-wider [&>p]:mb-6 [&>p]:mt-0">
        <PrismicRichText field={data.cta_title} />
        <PrismicRichText field={data.cta_content} />

        <button className="btn btn-primary btn-default btn-interaction !w-fit" onClick={handleClick}>
          {data.cta_button_text}
          <Image src="/images/angle-right-green.svg" width={20} height={16} alt="" aria-hidden="true" />
        </button>
      </div>

      <div className="[&>img]:m-0 [&>img]:max-h-[350px] [&>img]:object-contain">
        <PrismicNextImage field={data.cta_logo} loading="eager" fallbackAlt="" />
      </div>
    </div>
  )
}

export default Product
